import { inject, Injectable, Service } from '@angular/core';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { CreateOrEditUserDTO } from 'app/back-office/shared/models/users/user.model';
import { environment } from 'environments/environment';
import { UserInfo } from '../models/user-info.model';
import { BasicHttpClientService } from './basic-http-client.service';

export interface Locale {
  lang: string;
  data: Object;
}

@Service()
export class CoreTranslationService {

  private readonly _baseUrl: string = environment.urls.apiUrl.url;

  private readonly _translateService = inject(TranslateService);
  private readonly _httpClient = inject(BasicHttpClientService);

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param {Locale} args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them
      this._translateService.setTranslation(locale.lang, locale.data as TranslationObject, true);
    });
  }

  updateUserCulture(user: CreateOrEditUserDTO, loaderId: string) {
    return this._httpClient.put<UserInfo>(this._baseUrl + `/users/${user.id}`, user, null, loaderId);
  }
}
